export default [
    {
        "name": "UN"
    },
    {
        "name": "KG"
    },
    {
        "name": "M"
    },
    {
        "name": "L"
    },
    {
        "name": "CX"
    }
]


// WEBPACK FOOTER //
// ./src/components/pages/products/utils/default-units.js